// extracted by mini-css-extract-plugin
module.exports = {"page":"Leaderboard_page__22xay Layout_page__3AEwV"};